<script setup lang="ts">
import Icon from "./Icon.vue";
import { QUICK_REACTIONS } from "../composables/reactions";
import { t } from "../i18n";
/** The quick reactions row: in the reaction picker and above or below a message's menu. */
defineProps<{ selected?: string | undefined; expanded?: boolean }>();
const emit = defineEmits<{ choose: [emoji: string]; more: [] }>();
</script>
<template>
  <div class="reaction-picker" role="group" :aria-label="t('reaction.quick')">
    <button
      v-for="emoji in QUICK_REACTIONS"
      :key="emoji"
      type="button"
      :aria-label="t('reaction.with', { emoji })"
      :aria-pressed="selected === emoji"
      :class="{ selected: selected === emoji }"
      @click="emit('choose', emoji)"
    >
      {{ emoji }}
    </button>
    <button
      type="button"
      class="reaction-more"
      :aria-label="t('reaction.more')"
      :aria-expanded="expanded"
      :class="{ selected: expanded }"
      @click="emit('more')"
    >
      <Icon name="plus" :size="25" />
    </button>
  </div>
</template>
